module.exports = __webpack_public_path__ + "img/fylke-20.0c770490.svg";